module.exports = __webpack_public_path__ + "static/media/used-cars-bg.43e2dbe6.png";